const CACHE_KEY='fitt';

export const cacheUrl = function(url){
  return new Promise((resolve)=>{
    caches.open(CACHE_KEY).then((cache)=>{
      cache.add(url).then(()=>{
        resolve(url);
      });
    });
  });
};

export const preloadImage = function(url){
  return new Promise((resolve)=>{
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      resolve(img);
    };
    img.src = url;
  });
};